import React, { useEffect, useState, useRef, useMemo } from "react";
import translate from "../../../i18n/translate";
import { useHistory } from "react-router-dom";
import SubNavOoredoo from "./SubNavOoredoo";
import { connect } from "react-redux";
import {
  getOoredooSuper,
  getOoredooSuperNotRenew,
  getOoredooSuperRenew,
} from "../../../actions/companiesAction";
import Selected from "./Selected";
import Badge from "../../ui/Badge/Badge";
import _ from "lodash";
import "./ooredoo.css";
import { dataLanguage } from "../../../i18n/translateRequest";
import CompaniesNav from "../../common/CompaniesNav";
import logo from "../../../assests/images/bundles/ooredoo/banner.jpg";
import { jsonParser } from "shared/utils/ppUtils";
import getOoredooCachedImageUrl from "shared/utils/ooredooImageCache";
import OoredooBundleCard from "./OoredooBundleCard";
// Removed MUI tabs - using card sections like Ooredoo website

const ShababOoredoo = ({
  getOoredooSuper,
  ooredooSuper,
  getOoredooSuperNotRenew,
  loading,
  getOoredooSuperRenew,
  isDarkTheme,
}) => {
  const history = useHistory().location.pathname;
  const mobileNo = history.split("/")[4];

  const [isRenew, setIsRenew] = useState(false);
  const [isNotRenew, setIsNotRenew] = useState(false);
  const [init, isInit] = useState(false);

  const [g3, setG3] = useState("");
  const [min, setMin] = useState("");
  const [credit, setCredit] = useState("");
  const [creditQueue, setCreditQueue] = useState([]);
  const [rom, setRom] = useState("");
  const [shabab, setShabab] = useState("");
  const [groupedBundles, setGroupedBundles] = useState({});
  const [columnStyle, setColumnStyle] = useState(
    "col-lg-3 col-md-4 col-sm-6 col-6"
  );
  const [imageRefreshToken, setImageRefreshToken] = useState(0);
  const collapseRef = useRef([]);
  const listRef = useRef(null);

  const handleCreditQueueChange = (queue) => {
    setCreditQueue(queue || []);
    setCredit(queue?.[queue.length - 1] || "");
  };

  useEffect(() => {
    getOoredooSuper(false);

    const handleSessionStorageChange = () => {
      document.title = "Ooredoo Shabab | Phone Play";

      if (sessionStorage.ooredoo3g) {
        setG3(jsonParser(sessionStorage.ooredoo3g));
      }
      if (sessionStorage.ooredooMin) {
        setMin(jsonParser(sessionStorage.ooredooMin));
      }
      // Load credit queue from sessionStorage
      if (sessionStorage.ooredooCreditQueue) {
        const parsedQueue = jsonParser(sessionStorage.ooredooCreditQueue);
        if (Array.isArray(parsedQueue) && parsedQueue.length) {
          handleCreditQueueChange(parsedQueue);
        }
      } else if (sessionStorage.ooredooCredit) {
        const parsedCredit = jsonParser(sessionStorage.ooredooCredit);
        if (parsedCredit) {
          handleCreditQueueChange([parsedCredit]);
        }
      } else {
        handleCreditQueueChange([]);
      }
      if (sessionStorage.ooredooRom) {
        setRom(jsonParser(sessionStorage.ooredooRom));
      }
      if (sessionStorage.ooredooSuper) {
        setShabab(jsonParser(sessionStorage.ooredooSuper));
      }
      refreshColumnStyle();
    };
    handleSessionStorageChange();

    window.addEventListener(
      "sessionStorageChanged",
      handleSessionStorageChange
    );

    // Clean up the event listener
    return () => {
      window.removeEventListener(
        "sessionStorageChanged",
        handleSessionStorageChange
      );
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mobileNo, history]);

  useEffect(() => {
    if (init) {
      getOoredooPackages();
    }
    isInit(true);

    document.addEventListener("click", handleClickOutside);

    return () => document.removeEventListener("click", handleClickOutside);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRenew, isNotRenew]);

  // Group Youth bundles by type (YOUTH-3G and YOUTH-MIN)
  useEffect(() => {
    if (Array.isArray(ooredooSuper) && ooredooSuper.length) {
      console.log("🔍 ShababOoredoo: Grouping bundles by type field");
      console.log("📦 Total Youth bundles received:", ooredooSuper.length);
      
      const sampleBundle = ooredooSuper[0];
      console.log("📋 Sample Youth bundle:", sampleBundle);
      console.log("🏷️ Sample Youth bundle type:", sampleBundle?.type);
      
      const grouped = ooredooSuper.reduce((acc, bundle) => {
        let bundleType = bundle?.type || "General";
        
        // Translate type names for display
        const translatedType = translateYouthBundleType(bundleType);
        
        if (!acc[translatedType]) {
          acc[translatedType] = [];
        }
        acc[translatedType].push(bundle);
        return acc;
      }, {});
      
      console.log("📊 Grouped Youth bundles:", Object.keys(grouped).map(cat => `${cat}: ${grouped[cat].length}`));
      
      setGroupedBundles(grouped);
    } else {
      console.log("⚠️ ShababOoredoo: No bundles to group");
      setGroupedBundles({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ooredooSuper]);

  // Translate Youth bundle type codes to display names
  const translateYouthBundleType = (type) => {
    const typeMap = {
      "YOUTH-3G": "3G",
      "YOUTH-MIN": "Minutes",
      "YOUTH": "All Youth",  // Backward compatibility for old bundles
      "General": "General"
    };
    
    const mappedType = typeMap[type];
    console.log(`🔄 Translating Youth type: "${type}" → "${mappedType || type}"`);
    return mappedType || type;
  };

  // Define category display configuration (order and Arabic titles)
  const categoryConfig = useMemo(() => {
    return [
      { key: "3G", arTitle: "حزم شباب 3G", enTitle: "Youth 3G Bundles", bgColor: "rgb(0, 65, 107)" },
      { key: "Minutes", arTitle: "حزم شباب الدقائق", enTitle: "Youth Minutes Bundles", bgColor: "rgb(237, 28, 36)" },
      { key: "All Youth", arTitle: "حزم شباب عامة", enTitle: "General Youth Bundles", bgColor: "rgb(0, 65, 107)" }
    ];
  }, []);

  // Get ordered categories that have bundles
  const orderedCategories = useMemo(() => {
    const categories = Object.keys(groupedBundles);
    console.log(`📋 Available Youth categories:`, categories);
    console.log(`📊 Youth category counts:`, categories.map(cat => `${cat}: ${groupedBundles[cat]?.length || 0}`));
    
    return categoryConfig.filter(config => categories.includes(config.key) && groupedBundles[config.key]?.length > 0);
  }, [groupedBundles, categoryConfig]);

  const handleClickOutside = (event) => {
    if (listRef.current && !listRef.current.contains(event.target)) {
      collapseRef.current.forEach((item) => {
        item?.classList?.remove("show");
      });
    }
  };

  const onTypeClick = (item) => {
    setShabab(item);
    document
      .getElementsByTagName("html")[0]
      .scrollIntoView({ behavior: "smooth" });

    sessionStorage.ooredooSuper = JSON.stringify(item);
  };

  const onRenewClick = () => {
    setIsRenew(!isRenew);
    setIsNotRenew(false);
    isInit(true);
  };
  const onNotRenewClick = () => {
    setIsNotRenew(!isNotRenew);
    setIsRenew(false);
    isInit(true);
  };
  const getOoredooPackages = () => {
    if (!isRenew && !isNotRenew) {
      getOoredooSuper(false);
    } else if (isRenew) {
      getOoredooSuperRenew();
    } else if (isNotRenew) {
      getOoredooSuperNotRenew();
    }
  };
  const refreshClick = () => {
    setImageRefreshToken(Date.now());
    getOoredooSuper(true);
  };

  const refreshColumnStyle = () => {
    switch (localStorage.size) {
      case "default":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
        break;
      case "column3":
        setColumnStyle("col-lg-4 col-md-6 col-sm-6 col-6 card-lg");
        break;
      case "column4":
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6  card-md");
        break;
      case "column6":
        setColumnStyle("col-lg-2 col-md-2 col-sm-4 col-6 card-sm");
        break;
      default:
        setColumnStyle("col-lg-3 col-md-4 col-sm-6 col-6");
    }
  };
  let topDiv = null;

  return (
    <>
      <div ref={(ref) => (topDiv = ref)}>
        <div className="ooredoo-container">
          <CompaniesNav
            providerId={window?.history?.state?.state?.provider_Id}
            title="Ooredoo"
            logo={logo}
            mobile={mobileNo}
            onRefresh={refreshClick}
            actionWidth="300px"
            backLink="/company/ooredoo/MobileNumer"
          >
            <button
              type="button"
              className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
                isRenew ? "selected-btn" : ""
              }`}
              onClick={onRenewClick}
            >
              {translate("Renewable")}
            </button>
            <button
              type="button"
              className={`btn btn-light btn-md btn-renewable main-text border-info border-left px-1 ${
                isNotRenew ? "selected-btn" : ""
              }`}
              onClick={onNotRenewClick}
            >
              {translate("notRenew")}
            </button>
          </CompaniesNav>

          <div className="row">
            <div className="col-12">
              <SubNavOoredoo mobile={mobileNo} />
            </div>
          </div>
        </div>
        <div className="position-relative">
          <Selected
            min={min}
            setMin={setMin}
            g3={g3}
            setg3={setG3}
            credit={credit}
            setCredit={setCredit}
            creditQueue={creditQueue}
            onCreditQueueChange={handleCreditQueueChange}
            shabab={shabab}
            setShabab={setShabab}
            setRom={setRom}
            rom={rom}
            imageRefreshToken={imageRefreshToken}
          />

          <hr
            className="mt-3"
            style={{
              border: "2px solid #42ace3",
              backgroundColor: "#42ace3",
              fontWeight: "bolder",
            }}
          />

          {/* Youth Bundle Categories - Display as separate card sections like Ooredoo website */}
          {orderedCategories.length === 0 ? (
            <div className={`${isDarkTheme ? "dark-card" : "card"} list-cards p-4`}>
              <div className="d-flex justify-content-center mt-3">
                <h2 className="text-info">
                  {translate("No available bundles")}
                </h2>
              </div>
            </div>
          ) : (
            orderedCategories.map((categoryConfig, catIndex) => {
              const categoryBundles = groupedBundles[categoryConfig.key] || [];
              let bundleIndex = 0;
              
              return (
                <div
                  key={categoryConfig.key}
                  className={`${isDarkTheme ? "dark-card" : "card"} list-cards p-4 mb-4`}
                  ref={catIndex === 0 ? listRef : null}
                >
                  {/* Category Header */}
                  <div 
                    className="text-white p-3 mb-3 rounded"
                    style={{ 
                      backgroundColor: categoryConfig.bgColor,
                      fontWeight: "bold",
                      fontSize: "1.2rem"
                    }}
                  >
                    {categoryConfig.arTitle}
                  </div>

                  {/* Category Bundles */}
                  <div className="row">
                    {categoryBundles.map((item) => {
                      const currentIndex = bundleIndex++;
                      const uniqueId = `${categoryConfig.key}-${currentIndex}`;
                      
                      return (
                        <div key={uniqueId} className={`${columnStyle} mt-3`}>
                          <div
                            className={`${
                              isDarkTheme ? "dark-card" : "card"
                            } charge-card`}
                          >
                            <a
                              href="#0"
                              style={{ cursor: "pointer" }}
                              data-placement="top"
                              title={item && item.des}
                              onClick={() => onTypeClick(item)}
                            >
                              <div className="position-relative">
                                <OoredooBundleCard
                                  item={item}
                                  size={localStorage.size || "default"}
                                />
                                {(item.auto_renew === "True" ||
                                  item.auto_renew === "true") && (
                                  <Badge text={translate("Renewable")}></Badge>
                                )}
                              </div>
                            </a>
                          </div>
                          <div className={`${isDarkTheme ? "dark-card" : "card"}`}>
                            <div className="text-center" id="headingOne">
                              <h5 className="mb-0 mx-">
                                <a
                                  className="link-main details"
                                  style={{ fontWeight: "bolder" }}
                                  data-toggle="collapse"
                                  data-target={"#" + uniqueId}
                                  aria-expanded="true"
                                  aria-controls={uniqueId}
                                >
                                  <small>{translate("Details")}</small>
                                </a>
                              </h5>
                            </div>

                            <div
                              id={uniqueId}
                              className="collapse"
                              aria-labelledby="headingOne"
                              data-parent="#accordion"
                              ref={(el) => (collapseRef.current[uniqueId] = el)}
                            >
                              <div className="card-body">
                                {dataLanguage(item, "ar-des", "en-des", "he-des")}
                                <br />
                                <p style={{ textAlign: "center" }}>{item.bundleid}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })
          )}
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  auth: state.auth,
  ooredooSuper: state.companies.ooredooSuper,
  loading: state.companies.loading,
  isDarkTheme: state.darkTheme.isDarktheme,
});

export default connect(mapStateToProps, {
  getOoredooSuper,
  getOoredooSuperRenew,
  getOoredooSuperNotRenew,
})(ShababOoredoo);
